import React from 'react';

const FacetMultiSelectComponent = ({ facetOptionResults, filterSelectedOption }) => (
    <React.Fragment>
        {facetOptionResults.map((option, index) => (
            <div className="sd-py-2 sd-pr-2" key={index}>
                <label aria-labelledby={`capacity-heading capacity_val${index + 1}`}>
                    <input
                        type="checkbox"
                        name={`option.docType_${index + 1}`}
                        id={`capacity_val${index + 1}`}
                        checked={option.selected}
                        onChange={() => filterSelectedOption(option)}
                    />
                    <p className="sd-flex sd-justify-between sd-pl-2 sd-w-full sd-mb-0 sd-capitalize">
                        {option.docType} {option.docCount ? `(${option.docCount})` : ''}
                    </p>
                </label>
               
            </div>

        ))}
    </React.Fragment>
);

export default FacetMultiSelectComponent;

